import UserSignature from '@/models/UserSignature/UserSignature';

export default class UserSignatureFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.userId  = '';
		this.userFirstName = '';
		this.name = '';
		this.signatureId  = '';
		this.signatureOriginalFilename = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			userId : '0',
			userFirstName : '0',
			name : '0',
			signatureId : '0',
			signatureOriginalFilename : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}